<template>
  <Portal>
    <Modal
      class="modal"
      title=""
      :is-open="isOpen"
      data-testid="error-modal"
      size="md"
      @close="emit('close')"
    >
      <div class="modal__wrapper">
        <HelperViewStatus
          :title="props.content.title"
          :description="props.content.description"
          status="alert"
        />
      </div>
      <ButtonContainer v-if="props.content.showButtonToLogin">
        <template #button-primary>
          <ButtonPrimary
            label="Acessar conta"
            @click="router.push({ name: 'login' })"
          />
        </template>
      </ButtonContainer>
    </Modal>
  </Portal>
</template>
<script setup lang="ts">
import {
  ButtonContainer,
  ButtonPrimary,
  HelperViewStatus,
  Modal
} from '@warrenbrasil/nebraska-web';
import { Portal } from '@/modules/common/components/Portal';
import { IErrorModalContent } from '@/modules/onboarding/signup/types';
import { PropType } from 'vue';
import { useRouter } from 'vue-router/composables';

const emit = defineEmits(['close']);
const props = defineProps({
  isOpen: { type: Boolean, default: false },
  content: {
    type: Object as PropType<IErrorModalContent>,
    default: () => ({ title: '', description: '' })
  }
});
const router = useRouter();
</script>
<style lang="less" scoped>
@navbar-height: 56px;

:deep(.modal-content) {
  padding: 0;
  @media screen and (max-width: 480px) {
    height: calc(100svh - @navbar-height);
    justify-content: space-between;
  }
}

.modal__wrapper {
  padding: 0 @size-spacing-x800 @size-spacing-x800 @size-spacing-x800;
}
</style>
